import { configurationSelectors, settingsSelectors, State, TabDisplayInterface } from '@wam/shared';
import { combineLatest, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { isStaff } from '@app/authentication/user.data';
import { Toggles } from '@app/shared/models/toggles.enum';
import { RosteringService } from '@app/teacher-users/rostering-data.service';

@Injectable({
  providedIn: 'root',
})
export class AssessmentsTabDisplayService implements TabDisplayInterface {
  isChildCareCenter$: Observable<boolean> = this.rosteringService
    .isChildCareCenter()
    .pipe(catchError(() => of(false)));

  constructor(
    private store: Store<State>,
    private rosteringService: RosteringService,
  ) {}

  isFirst(): Observable<boolean> {
    return of<boolean>(false);
  }

  shouldShow(): Observable<boolean> {
    return combineLatest([
      this.store.pipe(select(settingsSelectors.getUserType)),
      this.store.pipe(select(configurationSelectors.isEnabled(Toggles.ASSESSMENTS))),
      this.isChildCareCenter$,
    ]).pipe(
      map(
        ([userType, isEnabled, isChildCareCenter]) =>
          isEnabled && !isChildCareCenter && isStaff(userType),
      ),
    );
  }
}
